export default "__VITE_ASSET__DjUjFvVj__"